import React from "react";
import { useDraggable } from "@dnd-kit/core";
import ExerciseSlotItem from "../planner/ExerciseSlotItem";
import PropTypes from "prop-types";
import usePlanner from "features/planner/state/usePlanner";

function DraggableExerciseSlotItem({ exercise, maxLines, fontSize, compact, onEdit, day, index }) {
  const { removeExercise } = usePlanner();

  const { listeners, attributes, setNodeRef, isDragging } = useDraggable({
    id: `slot-item-${day}-${index}`,
    data: {
      type: "slot-item",
      exercise,
      day,
      index,
    },
  });

  const handleEdit = () => {
    // ahora avisamos exactamente del slot que quiere editar
    onEdit?.(day, index);
  };

  return (
    <ExerciseSlotItem
      ref={setNodeRef}
      exercise={exercise}
      maxLines={maxLines}
      fontSize={fontSize}
      compact={compact}
      onEdit={handleEdit}
      onDelete={() => removeExercise(day, index)}
      dragListeners={{ ...listeners, ...attributes }}
      isDragging={isDragging}
    />
  );
}

DraggableExerciseSlotItem.propTypes = {
  exercise: PropTypes.object.isRequired,
  maxLines: PropTypes.number.isRequired,
  fontSize: PropTypes.string.isRequired,
  compact: PropTypes.bool,
  day: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default DraggableExerciseSlotItem;
